module.exports = __webpack_public_path__ + "static/media/28-9.6984bfc6.mp3";